var app = angular.module('pageSizeModule', [
  'angularUtils.directives.dirPagination'
]);

function PageSizeController($scope) {
  $scope.currentPage = 1;
  $scope.pageSizeOptions = [
    {
      value: '5',
      id: 1
    },
    {
      value: '10',
      id: 2
    },
    {
      value: '25',
      id: 3
    },
    {
      value: '50', //default
      id: 4
    }
  ];
  $scope.selectedPageSize = $scope.pageSizeOptions[3];
  $scope.resetPage = function() {
    $scope.currentPage = 1;
  };
}

app.controller('PageSizeController', PageSizeController);
